import { render, staticRenderFns } from "./AddPracticeTest.vue?vue&type=template&id=e224ac3a&scoped=true"
import script from "./AddPracticeTest.vue?vue&type=script&lang=js"
export * from "./AddPracticeTest.vue?vue&type=script&lang=js"
import style0 from "./AddPracticeTest.vue?vue&type=style&index=0&id=e224ac3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e224ac3a",
  null
  
)

export default component.exports